import React, { CSSProperties } from 'react';


interface TextStyleCfg {
    bold?: boolean,
    largeFont?: boolean,  // large meaning 20px; otherwise 18px
    lineBreak?: boolean,  // the text can break into multiple lines
}

interface ItemStyleCfg {
    margin?: string,
}

export interface IPanelItem {
    header: string
    headerTextStyleCfg?: TextStyleCfg
    value: string | React.ReactNode
    valueTextStyleCfg?: TextStyleCfg
    valueTestId?: string
    testId?: string
    itemStyleCfg?: ItemStyleCfg
};


export const PanelItem = (props: IPanelItem) => {
    const itemStyle: CSSProperties = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        margin: props.itemStyleCfg?.margin || '0.2vh 0',
    };

    // When the value is allowed to wrap onto multiple lines, keep the header at
    // its natural width so a long value can't crush it down to an ellipsis.
    const valueCanWrap = props.valueTextStyleCfg?.lineBreak;

    const headerStyle: CSSProperties = {
        cursor: 'default',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: props?.headerTextStyleCfg?.bold ? 'bold' : 'normal',
        userSelect: 'none',
        whiteSpace: props?.headerTextStyleCfg?.lineBreak ? 'pre-line': 'nowrap' ,
        flexShrink: valueCanWrap ? 0 : undefined,
        margin: '0',
        padding: '0'
    };

    const valueStyle: CSSProperties = {
        margin: 0,
        overflow: 'hidden',
        // Let the value yield width to the header and wrap/right-align when it
        // can break; otherwise preserve the original single-line behaviour.
        minWidth: valueCanWrap ? 0 : undefined,
        paddingLeft: valueCanWrap ? '12px' : undefined,
        textAlign: valueCanWrap ? 'right' : undefined,
        overflowWrap: valueCanWrap ? 'break-word' : undefined,
        whiteSpace: valueCanWrap ? 'normal' : undefined,
        textOverflow: 'nowrap',
        fontWeight: props.valueTextStyleCfg?.bold ? 'bold' : 'normal',
        fontSize: props.valueTextStyleCfg?.largeFont ? '20px' : '18px',
    };

    return (
        <div style={itemStyle} data-testid={props.testId || 'infoItem'}>
            <p style={headerStyle}>{props.header || 'HEADER-NOT-SET'}</p>
            {/* checking for value type because it's not a good practice to hold a <div/> inside a <p/> tag, so a component/ReactNode would be standalone. */}
            {typeof props.value === 'object' ? props.value : <p style={valueStyle}>{props.value !== null && props.value !== undefined ? props.value : 'VALUE-NOT-SET'}</p>}
        </div>
    );
};
